import {Injectable} from "@angular/core";
import {ProductPerformance} from "../../models/product.model";
import {HttpClientService} from "../httpClient/httpclient.service";
import {DatePipe} from "@angular/common";
import {Observable} from "rxjs/Observable";

@Injectable()
export class ProductCampaignService {
  product_performance: ProductPerformance;
  public max_date: Date;
  public min_date: Date;
  public date_from: Date;
  public date_to: Date;

  constructor (private h: HttpClientService,
               private datePipe : DatePipe
  ) {

  }

  getProductPerformance(category_depth: number, category: number, loyalty: string) : Observable<ProductPerformance> {
    let date_from_s : string = this.datePipe.transform(this.date_from, "yyyy-MM-dd");
    let date_to_s : string = this.datePipe.transform(this.date_to, "yyyy-MM-dd");

    return this.h.post("/koncentro-analytics/products-campaign/performance", {
      date_from: date_from_s,
      date_to: date_to_s,
      category_depth: category_depth,
      category: category,
      loyalty: loyalty
    })
      .map(res => {
        return this.product_performance = res;

      });

  }

  getProductsInterval() {
    return this.h.get("/koncentro-analytics/products-campaign/interval")
      .map(res => {
        this.max_date = new Date(res['max_date']);
        this.min_date = new Date(res['min_date']);
        return res;
    })
  }


}



// WEBPACK FOOTER //
// ./src/app/services/product/product-campaign.service.ts